import { NgModule } from "@angular/core";
import { TruncatePipe } from "./truncate.pipe";
import { InputErrorPipe } from "./input-error.pipe";
import { NoCommaPipe } from "./no-comma.pipe";

@NgModule({
  imports: [],
  declarations: [TruncatePipe, InputErrorPipe, NoCommaPipe],
  exports: [TruncatePipe,InputErrorPipe, NoCommaPipe],
})
export class CustomPipeModule {}
